import { notification, Progress } from "antd";
import { InvoiceProgressType } from "../../Types/invoiceManagementTypes";
import styles from "./invoiceManagement.module.scss";
import ProgressNotificationDescription from "./NotificationDescription";
import { ViewListingTypes } from "../../enums/ViewListingTypes";
import { QueryKeys } from "../../constants/QueryKeys";

export const invoiceManagementConsts = {
  ROLE_DETAILS_KEY: "userRoleInfo",
  PROFILE_DETAILS_KEY: "userProfile",
  EDIT_ROLE: "Edit",
  PROGRESS_NOTIF_KEY: "progressNotif",
  GENERATION_SUCCESS: "Invoice generation completed successfully",
  GENERATION_PARTIAL_COMPLETE: "Invoice Generation process completed, some invoices failed to generate",
  GENERATION_FAILED: "Invoice generation failed, please retry",
  REFRESH_ALT: "Click to refresh progress",
  PROGRESS_COLOR: "#586370",
};

export const refreshKey = {
  [ViewListingTypes.LIST]: QueryKeys.FETCH_INVOICE_MANAGEMENT_LIST_KEY,
  [ViewListingTypes.KANBAN]: QueryKeys.INVOICE_MANAGEMENT_TILE_KEY,
}

export const showInvoiceNotification = (
  progressData: InvoiceProgressType,
  refetchAction: () => void,
) => {
  notification.open({
    key: invoiceManagementConsts.PROGRESS_NOTIF_KEY,
    className: styles.progressNotif,
    top: 20,
    description: (
      <ProgressNotificationDescription 
        progressData={progressData}
        refetchAction={refetchAction}
      />
    ),
    duration: 7,
  });
};
